import { rechargeOptions } from "constants/subscriptions";

import { useMemo } from "react";

import { Typography, Box, Grid } from "@mui/material";
import Panel from "components/elements/Panel";
import { useUserDataContext } from "context/UserDataContext";
import { Trans, useTranslation } from "react-i18next";
import { SubscriptionType } from "types/enums";

import Card from "./Card";

const Recharge = () => {
  const { subscriptionType, creditsRechargeType } = useUserDataContext();
  const { t } = useTranslation();

  const hasActivePremiumRecharge = () => {
    const premiumRecharges = rechargeOptions.find((option => option.unlocks === SubscriptionType.PREMIUM));
    
    return premiumRecharges?.type === creditsRechargeType || premiumRecharges?.prevType === creditsRechargeType
  }

  const filteredOptions = useMemo(() => {
    const isPremiumRechargeActive = hasActivePremiumRecharge();
    if (subscriptionType === SubscriptionType.PRO && !isPremiumRechargeActive) {
      return rechargeOptions.filter((option) => option.unlocks === SubscriptionType.PRO);
    }
    return rechargeOptions;
  }, [subscriptionType, creditsRechargeType]);

  return (
    <Panel id={"mesicni-platba"} shadow={false} sx={{ width: "100%", p: { xs: 2, md: 3 }, mb: 4 }}>
      <Typography variant="h5" component="h1" fontWeight={600} sx={{ pb: 1, color: "tertiary.main" }}>
        {t("recharge.title")}
      </Typography>
      <Typography variant="subtitle2" fontWeight={400}>
        <Trans i18nKey="recharge.description" />
      </Typography>
      <Box pt={4} pb={1}>
        <Grid container spacing={3} alignItems={"stretch"}>
          {filteredOptions.map((option) => (
            <Grid item xs={12} md={6} height="auto" key={option.type}>
              <Card {...option} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Panel>
  );
};

export default Recharge;
